import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../env";


export const fetchHotel = createAsyncThunk(
  "hotels/fetchHotel",
  async () => {
    try {
      const response = await axios.get(`${REACT_APP_API_URL}api/dashboard/admin/hotels`);  
    
      return response.data.data;  
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);  
    }
  }
);

const hotelSlice = createSlice({
  name: "hotels",
  initialState: {
    hoteldata: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchHotel.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchHotel.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.hoteldata = action.payload;
        state.error = null;  
      })
      .addCase(fetchHotel.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message; 
      });
  },
});

export default hotelSlice.reducer;